import React from 'react'
import { useParams } from 'react-router-dom'
import { graphql, useLazyLoadQuery } from 'react-relay/hooks'
import TemplatesTable from './TemplatesTable'

export default function TemplatesContainer() {
  const params = useParams()
  const slug = params.orgSlug

  const data = useLazyLoadQuery(
    graphql`
      query TemplatesContainerQuery($slug: String!) {
        organizationBySlug(slug: $slug) {
          ...TemplatesTable_organization
        }
      }
    `,
    { slug },
  )

  const organization = data?.organizationBySlug

  if (!organization) {
    return null
  }

  return <TemplatesTable organization={organization} />
}
